import { useSampleHousehold } from '@/hooks/useSampleHousehold'

export function ExploreSampleLink({ lead, label }: { lead: string; label: string }) {
  const { sample, startCreate, dialogs } = useSampleHousehold()

  if (sample) return null

  return (
    <>
      <p className="text-sm text-[var(--fl-text-2)]">
        {lead}{' '}
        <button
          type="button"
          onClick={startCreate}
          className="font-medium text-[var(--fl-primary)] hover:underline"
        >
          {label}
        </button>
      </p>
      {dialogs}
    </>
  )
}
